var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),(_vm.env && _vm.env !== 'production')?_c('div',{staticClass:"pre-tip focus-input-item"},[_vm._v("公测")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }